<template>
  <NotificationList />
</template>

<script>
import NotificationList from '@/components/Notification/NotificationList.vue';
export default {
  components: { NotificationList },
};
</script>

<style lang="scss" scoped></style>
